/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/owl_medium'
export default icon
